export class DropdownDataTable {
    domains = [
        {
            name: '', subdomains:
            [
                {name: '',
                    categories: []
            }
            ]
        },
        {
            name: 'Agricultura', subdomains:
                [
                    {name: 'Cereale',
                        categories: ['Grau', 'Porumb', 'Orz, orzoaica', 'Orez']
                    },
                    {name: 'Plante tehnice',
                        categories: ['Floarea soarelui', 'Rapita pentru ulei', 'Sfecla de zahar', 'Culturile de in si canepa pentru fibra', 'Tutun si hamei', 'Soia']
                    },
                    {name: 'Plante furajere',
                        categories: ['Lucerna', 'Sfecla Furajera', 'Trifoi', 'Pasuni', 'Mazare Furajera', 'Sudan', 'Porumb Furajer']
                    },
                    {name: 'Plante Medicinale si Aromatice',
                        categories: ['Plante Medicinale', 'Plante Aromatice']
                    },
                    {name: 'Inputuri Agricole',
                        categories: ['Seminte', 'Pesticide', 'Fertilizanti']
                    },
                    {name: 'Altele',
                        categories: []
                    },
                ]
        },
        {
            name: 'Horticultura', subdomains:
                [
                    {name: 'Legumicultura',
                        categories: ['Ardei', 'Iute', 'Castraveti', 'Ceapa', 'Conopida', 'Dovlecei', 'Fasole', 'Morcov', 'Patrunjel', 'Pepene', 'Pepene Galben', 'Porumb Zaharat', 'Praz',
                            'Salata', 'Sfecla', 'Spanac', 'Telina', 'Tomate', 'Varza', 'Vinete']
                    },
                    {name: 'Pomicultura',
                        categories: ['Măr', 'Păr', 'Gutui', 'Prun', 'Cireş', 'Vişin', 'Cais', 'Piersic', 'Nectarin', 'Nuc', 'Migdal', 'Alun', 'Castan', 'Zmeur', 'Mur', 'Coacăz',
                            'Agriş', 'Afin', 'Căpşun', 'Corn', 'Cătină', 'Măceş', 'Trandafirul pentru petale']
                    },
                    {name: 'Viticultura',
                        categories: ['Struguri de Masa', 'Struguri de Vinificatie']
                    },
                    {name: 'Floricultura Si Amenajari Peisagistice',
                        categories: []
                    },
                    {name: 'Inputuri Agricole',
                        categories: ['Seminte', 'Pesticide', 'Fertilizanti']
                    },
                    {name: 'Sere, Solarii, Echipamente',
                        categories: []
                    },
                    {name: 'Material saditor',
                        categories: []
                    },
                    {name: 'Altele',
                        categories: []
                    },
                ]
        },
        {
            name: 'Zootehnie', subdomains:
                [
                    {name: 'Bovine',
                        categories: ['Bovine de lapte', 'Bovine de carne', 'Mixte']
                    },
                    {name: 'Caprine',
                        categories: ['Caprine de lapte', 'Caprine de carne', 'Mixte']
                    },
                    {name: 'Ovine',
                        categories: ['Ovine de lapte', 'Ovine de carne', 'Ovine de lana', 'Mixte']
                    },
                    {name: 'Suine',
                        categories: []
                    },
                    {name: 'Pasari',
                        categories: ['Pasari de carne', 'Pasari de oua', 'Mixte']
                    },
                    {name: 'Peste',
                        categories: []
                    },
                    {name: 'Cabaline',
                        categories: []
                    },
                    {name: 'Animale de Companie',
                        categories: []
                    },
                    {name: 'Nutritie Animala',
                        categories: []
                    },
                    {name: 'Reproductie animala',
                        categories: []
                    },
                    {name: 'Genetica Animala',
                        categories: []
                    },
                    {name: 'Altele',
                        categories: []
                    },
                ]
        },
        {
            name: 'Medicina veterinara', subdomains:
                [
                    {name: 'Bovine',
                        categories: ['Bovine de lapte', 'Bovine de carne', 'Mixte']
                    },
                    {name: 'Caprine',
                        categories: []
                    },
                    {name: 'Ovine',
                        categories: []
                    },
                    {name: 'Suine',
                        categories: []
                    },
                    {name: 'Pasari',
                        categories: ['Pasari de carne', 'Pasari de oua', 'Mixte']
                    },
                    {name: 'Peste',
                        categories: []
                    },
                    {name: 'Cabaline',
                        categories: []
                    },
                    {name: 'Animale de Companie',
                        categories: []
                    },
                    {name: 'Medicamente Uz Veterinar',
                        categories: []
                    },
                    {name: 'Instrumentar Laborator Si Ferme',
                        categories: []
                    },
                    {name: 'Analize medicale',
                        categories: []
                    },
                    {name: 'Altele',
                        categories: []
                    },
                ]
        },
        {
            name: 'Industria Alimentara', subdomains:
            [
                {name: 'Lactate Si Produse Lactate', categories:[]},
                {name: 'Carne Si Mezeluri', categories:[]},
                {name: 'Paine Si Produse Panificatie', categories:[]},
                {name: 'Bauturi Alcoolice Si Non Alcoolice', categories:[]},
                {name: 'Oua', categories:[]},
                {name: 'Peste', categories:[]},
                {name: 'Uleiuri Alimentare', categories:[]},
                {name: 'Ingrediente Alimentare', categories:[]},
                {name: 'Uleiuri Non Alimentare', categories:[]},
                {name: 'Procesatori Industria Alimentara', categories:[]},
                {name: 'Producatori Industria Alimentara', categories:[]},
                {name: 'Echipamente  Industria Alimentara', categories:[]},
                {name: 'Retail', categories:[]},
                {name: 'Altele', categories:[]}
            ]
        },
        {
            name: 'Masini si utilaje agricole', subdomains:
                [
                    {name: 'Masini Agricole, Horticole, Zootehnice', categories:['Tractoare', 'Combine', 'Masini Autopropulsate', 'Masini Tractate', 'Remorci']},
                    {name: 'Utilaje Agricole, Horticole, Zootehnice', categories:[]},
                    {name: 'Piese De Schimb', categories:[]},
                    {name: 'Echipamente', categories:[]},
                    {name: 'Roboti', categories:[]},
                    {name: 'Sisteme De Irigatii', categories:['Tambur', 'Liniar', 'Pivot', 'Aspersie', 'Picurare']},
                    {name: 'Solutii Transport', categories:[]},
                    {name: 'Combustibili Si Uleiuri', categories:[]},
                    {name: 'Servicii Mecanizare', categories:[]},
                    {name: 'Altele', categories:[]}
                ]
        },
        {
            name: 'Depozitare si Ambalare', subdomains:
                [
                    {name: 'Depozitare', categories:[]},
                    {name: 'Conditionare', categories:[]},
                    {name: 'Insacuire', categories:[]},
                    {name: 'Sortare', categories:[]},
                    {name: 'Ambalare', categories:[]},
                    {name: 'Etichetare', categories:[]},
                    {name: 'Altele', categories:[]}
                ]
        },
        {
            name: 'Agricultura Smart (Digitala si de Precizie)', subdomains:
                [
                    {name: 'Soft Managementul Fermei', categories:[]},
                    {name: 'Soft Managementul Culturilor', categories:[]},
                    {name: 'Soft Managementul Precipitatiilor', categories:[]},
                    {name: 'Drone', categories:[]},
                    {name: 'Statii Meteo', categories:[]},
                    {name: 'Senzori', categories:[]},
                    {name: 'Gps', categories:[]},
                    {name: 'Roboti', categories:[]},
                    {name: 'Altele', categories:[]},
                ]
        },
        {
            name: 'Constructia si Intretinerea Fermei / Fabricii', subdomains:
                [
                    {name: 'Proiectare', categories:[]},
                    {name: 'Materiale De Constructii', categories:[]},
                    {name: 'Echipamente Pentru Ferma', categories:[]},
                    {name: 'Sisteme De Ventilare', categories:[]},
                    {name: 'Sisteme De Incalzire', categories:[]},
                    {name: 'Garduri', categories:[]},
                    {name: 'Sisteme De Securitate', categories:[]},
                    {name: 'Scule, Consumabile Pentru Ferma', categories:[]},
                    {name: 'Echipamente De Protectie', categories:[]},
                    {name: 'Echipamente Pentru Curatenie', categories:[]},
                    {name: 'Produse De Igiena Si Dezinfenctanti', categories:[]},
                    {name: 'Altele', categories:[]},
                ]
        },
        {
            name: 'Managementul Resturilor Vegetale Si Animale', subdomains:
                [
                    {name: 'Gestionarea Dejectiiilor', categories:[]},
                    {name: 'Prelucararea Resturilor Vegetale', categories:[]},
                    {name: 'Statii De Biogaz', categories:[]},
                    {name: 'Echipamente Si Instalatii', categories:[]},
                    {name: 'Altele', categories:[]},
                ]
        },
        {
            name: 'Servicii', subdomains:
                [
                    {name: 'Cercetare Stiintifica', categories:[]},
                    {name: 'Testare Si Multiplicare ', categories:[]},
                    {name: 'Cercetari De Piata Agricole', categories:[]},
                    {name: 'Cercetari De Piata Zootehnice', categories:[]},
                    {name: 'Cercetari De Piata Alimentare', categories:[]},
                    {name: 'Consultanta  De Specialitate', categories:[]},
                    {name: 'Analize agrochimice sol', categories:[]},
                    {name: 'Cadastru-Topo', categories:[]},
                    {name: 'Analiza organoleptică', categories:[]},
                    {name: 'Analize Laborator', categories:[]},
                    {name: 'Servicii De Mecanizare', categories:[]},
                    {name: 'Servicii De Depozitare Si Ambalare', categories:[]},
                    {name: 'Finantare Bancara Si Nonbancara', categories:[]},
                    {name: 'Leasing', categories:[]},
                    {name: 'Fonduri Europene', categories:[]},
                    {name: 'Asigurari', categories:[]},
                    {name: 'Resurse Umane', categories:[]},
                    {name: 'Financiar-Contabilitate', categories:[]},
                    {name: 'Audit ', categories:[]},
                    {name: 'Certificari', categories:[]},
                    {name: 'Training Si Dezvoltare Profesionala Si Personala', categories:[]},
                    {name: 'Protectia Mediului', categories:[]},
                    {name: 'Consultanta Fonduri Europene ', categories:[]},
                ]
        },
        {
            name: 'Piscicultura Si Acvacultura', subdomains:
                [
                    {name: 'Puiet Piscicol', categories:[]},
                    {name: 'Nutritie Piscicola', categories:[]},
                    {name: 'Echipamente Piscicole', categories:[]},
                    {name: 'Altele', categories:[]}
                ]
        },
        {
            name: 'Apicultura', subdomains:
                [
                    {name: 'Familii De Albine', categories:[]},
                    {name: 'Stupii, Accesorii Apicole', categories:[]},
                    {name: 'Altele', categories:[]},
                ]
        },
        {
            name: 'Silvicultura', subdomains:
                [
                    {name: 'Infiintarea Plantatiilor', categories:[]},
                    {name: 'Intretinerea Plantatiilor', categories:[]},
                    {name: 'Altele', categories:[]},
                ]
        },
        {
            name: 'Alte domenii', subdomains:[
                {name:'Alte subdomenii', categories:[]}
            ]
        }

    ]

    candidatesSorting = [
        {
            value: "firstName",
            name: "Prenume"
        },
        {
            value: "lastName",
            name: "Nume"
        },
        {
            value: "email",
            name: "Email"
        },
        {
            value: "telephone",
            name: "Telefon"
        },
        {
            value: "userCountry",
            name: "Tara"
        },
        {
            value: "city",
            name: "Oras"
        },
        {
            value: "civilStatus",
            name: "Status civil"
        },
        {
            value: "gender",
            name: "Gen"
        },
        {
            value: "userActivitySector",
            name: "Domeniu"
        },
        {
            value: "userActivitySubSector",
            name: "Subdomeniu"
        },
        {
            value: "category",
            name: "Categorie"
        },
        {
            value: "userDepartment",
            name: "Departament"
        },
        {
            value: "regionOfInterest",
            name: "Regiune de interes"
        },
        {
            value: "availabilityOfRelocation",
            name: "Disponibilitate relocare"
        },
        {
            value: "workPermissionInEu",
            name: "Permis de munca in UE"
        },
        {
            value: "currentExperienceLevel",
            name: "Nivelul experientei actuala"
        },
        {
            value: "desiredLevelOfJob",
            name: "Nivel de job dorit"
        },
        {
            value: "jobType",
            name: "Tip job"
        },
        {
            value: "availableForWork",
            name: "Disponibilitate angajare"
        },
        {
            value: "currentJob",
            name: "Status job actual"
        },
        {
            value: "studies",
            name: "Studii"
        },
        {
            value: "languages",
            name: "Limbi straine"
        },
        {
            value: "driverLicense",
            name: "Permis de conducere"
        },
        {
            value: "userAvailableForTraveling",
            name: "Disponibilitate deplasare"
        },
        {
            value: "userWorkProgram",
            name: "Program de lucru"
        },
        {
            value: "userWorkSpace",
            name: "Spatiu de lucru"
        },
        {
            value: "physicalEffortAvailability",
            name: "Disponibilitate efort fizic"
        },
        {
            value: "weightLiftingAvailability",
            name: "Ridicare greutati"
        },
        {
            value: "workTemperature",
            name: "Diferite temperaturi"
        },
        {
            value: "userCommute",
            name: "Dispus naveta"
        },
        {
            value: "interestedInBonusSystem",
            name: "Interesat de bonusare"
        },
        {
            value: "mandatoryMealVoucher",
            name: "Bonuri de masa"
        },
        {
            value: "mandatoryHolidayVoucher",
            name: "Bonuri de vacanta"
        },
        {
            value: "mandatoryServiceCar",
            name: "Masina de serviciu"
        },
        {
            value: "mandatoryHealthPackage",
            name: "Pachet de sanatate"
        },
        {
            value: "mandatoryFood",
            name: "Masa obligatorie"
        },
        {
            value: "mandatoryAccommodation",
            name: "Cazare obligatorie"
        },
        {
            value: "coursesInTheCountry",
            name: "Cursuri in tara"
        },
        {
            value: "coursesAboard",
            name: "Cursuri in afara tarii"
        }

    ]

    clientsSorting = [
        {
            value: "companyName",
            name: "Nume companie"
        },
        {
            value: "fiscalCode",
            name: "Cod fiscal"
        },
        {
            value: "activitySector",
            name: "Domeniu"
        },
        {
            value: "companyActivitySubSector",
            name: "Subdomeniu"
        },
        {
            value: "companyType",
            name: "Tip companie"
        },
        {
            value: "companyEmployeesLevel",
            name: "Nivel companie"
        },
        {
            value: "rating",
            name: "Rating"
        },
    ]

    jobsSorting = [
        {
            value: "jobPostingDate",
            name: "Data postării"
        },
        {
            value: "jobTitle",
            name: "Titlu job"
        },
        {
            value: "country",
            name: "Țară"
        },
        {
            value: "city",
            name: "Oraș"
        },
        {
            value: "relocationPossibility",
            name: "Posibilitate Relocaree"
        },
        {
            value: "workType",
            name: "Tip Job"
        },
        {
            value: "contractType",
            name: "Tip Contract"
        },
        {
            value: "experienceLevel",
            name: "Nivel Experiență"
        },
        {
            value: "jobDisponibility",
            name: "Disponibilitate"
        },
        {
            value: "activitySector",
            name: "Domeniu"
        },
        {
            value: "activitySubSector",
            name: "Subdomeniu"
        },
        {
            value: "department",
            name: "Departament"
        },
        {
            value: "category",
            name: "Categorie"
        },
        {
            value: "studies",
            name: "Studii"
        },
        {
            value: "foreignLanguage",
            name: "Limbi străine"
        },
        {
            value: "driverLicense",
            name: "Permis de conducere"
        },
        {
            value: "availableForTraveling",
            name: "Disponibilitate la Deplasare"
        },
        {
            value: "totalExperience",
            name: "Experiență Totală de Muncă"
        },
        {
            value: "similarExperience",
            name: "Experiență în departamente similare"
        },
        {
            value: "legalWorkPermitMandatory",
            name: "Permis de Muncă Obligatoriu"
        },
        {
            value: "bonus",
            name: "Bonus"
        },
        {
            value: "otherBenefits",
            name: "Alte beneficii"
        },
        {
            value: "careerPossibility",
            name: "Oportunități de carieră"
        },
        {
            value: "workProgram",
            name: "Program de lucru"
        },
        {
            value: "workSpace",
            name: "Spațiu de lucru"
        },
        {
            value: "physicalEffort",
            name: "Efort fizic"
        }
    ]

    projectsSorting = [
        {
            value: "name",
            name: "Nume proiect"
        },
        {
            value: "projectNumber",
            name: "Numar proiect"
        },
        {
            value: "clientName",
            name: "Nume client"
        },
        {
            value: "status",
            name: "Status proiect"
        }
        ]

    departments = [
        'Abatorizare',
        'Achizitii',
        'Achizitii animale',
        'Achizitii cereale si plante tehnice',
        'Achizitii legume',
        'Administrare ferme',
        'Administratia statului',
        'Admistrativ, servicii suport',
        'Agricultura digitala (hardware si software)',
        'Asigurarea calitatii',
        'Asigurari',
        'Asigurari agricole',
        'Audit',
        'Audit calitate',
        'Audit contabil',
        'Automatizari',
        'Banci / Servicii financiare',
        'Biochimie',
        'Bioenergie',
        'Biogaz',
        'Biolog',
        'Biosecuritatea produselor alimentare',
        'Biotehnolog',
        'Cadastru-Imobiliare',
        'Call center',
        'Cercetare de piață',
        'Cercetare-dezvoltare',
        'Certificare calitate',
        'Certificare standarde servicii',
        'Chimie',
        'Clinici veterinare',
        'Comert / Retail',
        'Constructii',
        'Consultanta de specialitate',
        'Contabilitate',
        'Controlul calității produselor agroalimentare',
        'Controlul si expertiza produselor agroalimentare',
        'Credit control',
        'Cultivarea plantelor',
        'Curatenie ',
        'Depozitare-Pastrare-Conditionare',
        'Echipamente',
        'Economie agricola',
        'Educatie, training',
        'Energie eoliana',
        'Energie solara',
        'Enologie',
        'Expozitii agro-alimentare',
        'Fabricarea mezelurilor',
        'Financiar-contabil',
        'Finantari bancare si non bancare',
        'Genetica si ameliorarea animalelor',
        'Genetică şi ameliorarea plantelor',
        'Geodezie',
        'Gestiune',
        'Grafica-Webdesign -DTP',
        'Hidrologie',
        'Imbunatatiri funciare',
        'Import – export',
        'Inginerie',
        'Internet / e-Commerce',
        'IT Hardware',
        'IT Software',
        'Juridic',
        'Jurnalism',
        'Laborator, analize',
        'Lemn si produse derivate',
        'Logistica',
        'Macelarie',
        'Management',
        'Marketing',
        'Medicina veterinara',
        'Merchandising / Promoteri',
        'Nutritia plantelor',
        'Nutritia si alimentatia animalelor',
        'Office / Back-office',
        'ONG / Voluntariat',
        'Pedologie',
        'Piscicultura si acvacultura',
        'Procesare',
        'Productie alimentara',
        'Productie horticola',
        'Productie vegetala',
        'Productie zootehnica',
        'Produse de curatenie, dezinfectie',
        'Produse petrochimice, energie verde',
        'Proiectare civila / industriala',
        'Proiectare sisteme de irigatii',
        'Protectia mediului',
        'Protectia muncii',
        'Protectia plantelor',
        'Publicitate',
        'Relatii clienti',
        'Relatii publice',
        'Reproductie animala',
        'Resurse Umane',
        'Sanatate si securitate in munca',
        'Secretariat',
        'Service / Reparatii',
        'Servicii financiare',
        'Servicii mecanizare',
        'Software agricol',
        'Somelier',
        'Statistica ',
        'Tehnologia cultivarii arborilor si arbustilor fructiferi',
        'Tehnologie alimentara ',
        'Tehnologii  în industria alimentară',
        'Tehnologii de crestere a animalelor',
        'Tehnologii de procesare a produselor agroalimentare',
        'Telecomunicatii',
        'Telemarketing',
        'Telesales',
        'Tipografii / Edituri',
        'Topografie',
        'Trading',
        'Transport / Distributie',
        'Turism-Agroturism',
        'Utilaje si service industrie alimentara',
        'Vanzari',
        'Vanzari produse fertilizarea plantelor',
        'Vanzari produse protectia plantelor',
        'Vanzari seminte',
        'Vanzari-Distributie',
        'Viticultura',
        'Alte departamente'
    ]
    
    
    jobType=[
        {
            id: "volunteer",
            text: "Voluntariat"
        },
        {
            id: "practice",
            text: "Practica"
        },
        {
            id: "project",
            text: "Proiect"
        },
        {
            id: "temporary",
            text: "Temporar"
        },
        {
            id: "part_time",
            text: "Part-Time"
        },
        {
            id: "full_time",
            text: "Full-Time"
        },
        {
            id: "remote",
            text: "La Distanta(Remote)"
        },
        {
            id: "internship",
            text: "Internship"
        }
    ]
}
